import { DisplayGiftMessage } from '@lessonup/teacher-modern';
import { teacherHome } from '@lessonup/typescript-core/services';
import qs from 'qs';
import React from 'react';
import { ClientOnlyModernWrapper } from '../../../utils/bridge/ClientOnlyModernWrapper';
import { withQueryString } from '../../../utils/routeUtils/routeUtils';

export const DisplayGiftPageView = () => {
  const onNext = () => {
    window.open(withQueryString(teacherHome(), qs.stringify({ 'welcome-tour': true })), '_self');
  };

  return (
    <ClientOnlyModernWrapper>
      <DisplayGiftMessage onNext={onNext} />
    </ClientOnlyModernWrapper>
  );
};
